export const NUMERIC_FEE_VALUES = `numericFeePropertyValues`;
export const STRING_FEE_VALUES = `stringFeePropertyValues`;
export const enum eFeePropertyNames {
  Amount = 'amount',
  Authority = 'authority',
  BillingAmount = 'billingAmount',
  BillingPeriod = 'billingPeriod',
  BuyerPaid = 'buyerPaid',
  BuyerPaidAmount = 'buyerPaidAmount',
  BuyerPaidAtClosing = 'buyerPaidAtClosing',
  BuyerPaidBeforeClosing = 'buyerPaidBeforeClosing',
  BorrowerPaid = 'borrowerPaid',
  BorrowerPaidAmount = 'borrowerPaidAmount',
  BorrowerPaidAtClosing = 'borrowerPaidAtClosing',
  BorrowerPaidBeforeClosing = 'borrowerPaidBeforeClosing',
  DateFrom = 'dateFrom',
  DateTo = 'dateTo',
  DayRate = 'dayRate',
  FeeCategory = 'feeCategory',
  GoodThruDate = 'goodThruDate',
  HiddenTotals = 'hiddenTotals',
  isPricingValid = 'isPricingValid',
  Name = 'name',
  NettedOut = 'nettedOut',
  NumberOfMonths = 'numberOfMonths',
  OthersPaid = 'othersPaid',
  OthersPaidBuyer = 'othersPaidBuyer',
  SendingToSpruceBuyer = 'sendingToSpruceBuyer',
  OthersPaidSeller = 'othersPaidSeller',
  SendingToSpruceSeller = 'sendingToSpruceSeller',
  PageCount = 'pageCount',
  Payee = 'payee',
  PerDiem = 'perDiem',
  PercentageOfLoanAmount = 'percentageOfLoanAmount',
  RatePerMonth = 'ratePerMonth',
  RecordingParty = 'recordingParty',
  SellerPaid = 'sellerPaid',
  SellerPaidAmount = 'sellerPaidAmount',
  SellerPaidAtClosing = 'sellerPaidAtClosing',
  SellerPaidBeforeClosing = 'sellerPaidBeforeClosing',
  SendingToSpruce = 'sendingToSpruce',
  Status = 'status',
  Reason = 'reason',
}

export const currencyFields = [
  eFeePropertyNames.Amount,
  eFeePropertyNames.BuyerPaid,
  eFeePropertyNames.BuyerPaidAtClosing,
  eFeePropertyNames.BuyerPaidAmount,
  eFeePropertyNames.BuyerPaidBeforeClosing,
  eFeePropertyNames.BorrowerPaid,
  eFeePropertyNames.BorrowerPaidAtClosing,
  eFeePropertyNames.BorrowerPaidAmount,
  eFeePropertyNames.BorrowerPaidBeforeClosing,
  eFeePropertyNames.SellerPaid,
  eFeePropertyNames.SellerPaidAtClosing,
  eFeePropertyNames.SellerPaidAmount,
  eFeePropertyNames.SellerPaidBeforeClosing,
  eFeePropertyNames.OthersPaid,
];

export const NETTEDOUT = {
  TRUE: ['TRUE', 'true'],
  FALSE: ['FALSE', 'false'],
};
